var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "App" }, [
    _c("header", [
      _c("h1", [_vm._v("Random Anime Picker")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "Header-menu" },
        [_c("History", { on: { "click-history-entry": _vm.showAnime } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "App-container" },
      [_c("Anime", { attrs: { anime: _vm.anime } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }